const pageCenter = {
    justifyContent: "center",
    position: "absolute",
    width: "100%",
};

export default (theme) => ({
    anchor: {
        margin: `0 ${theme.spacing(2)}`,
    },
    auditContainer: {
        padding: `0`,
    },
    auditProgressHeading: {
        marginBottom: theme.spacing(1),
    },
    auditProgressContainer: {
        display: "flex",
        flexGrow: 1,
        justifyContent: "center",
    },
    systemPermissionsContainer: {
        display: "flex",
        flexGrow: 1,
        flexFlow: "column",
        textAlign: "center",
        padding: theme.spacing(4),
    },
    auditProgressListContainer: {
        borderRight: `1px solid ${theme.palette.border.darkBorder}`,
        display: "block",
        padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
        "&:first-child": {
            paddingLeft: 0,
        },
        "&:last-child": {
            border: "none",
            paddingRight: 0,
        },
    },

    auditProgressCaption: {
        color: theme.palette.text.darkText,
        fontWeight: 500,
        fontSize: "0.7rem",
        textTransform: "uppercase",
    },
    auditProgressValue: {
        border: "none",
        backgroundColor: "transparent",
        fontSize: "1rem",
        color: theme.palette.text.darkText,
    },
    iconColor: {
        color: `${theme.palette.iconsColor.primary} !important`,
    },
    listContainer: {
        padding: theme.spacing(2),
    },
    buttons: {
        margin: `${theme.spacing(1)} 0`,
    },
    list: {
        borderBottom: `1px solid ${theme.palette.border.darkBorder}`,
        padding: `${theme.spacing(3)} ${theme.spacing(1)}`,
        "& > div:first-child": {
            minWidth: theme.spacing(5),
        },
    },
    link: {
        display: "block",
        padding: `${theme.spacing(0.5)} 0 `,
    },
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        boxShadow: 24,
        borderRadius: `${theme.spacing(1)}`,
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        whiteSpace: "nowrap",
        display: "flex",
    },
    progress: {
        alignSelf: "center",
        marginRight: `${theme.spacing(4)}`,
    },
    smallFontSize: {
        fontSize: "0.7rem",
    },
    spinnerContainer: {
        ...pageCenter,
        display: "flex",
        top: "50%",
    },

    alert: {
        marginTop: theme.spacing(1),
    },
    readme: {
        marginTop: theme.spacing(3),
    },
});
